"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalContext = exports.ModalContextProvider = void 0;
var react_1 = require("react");
var ModalContext = react_1.createContext(undefined);
exports.ModalContextProvider = ModalContext.Provider;
function useModalContext() {
    var context = react_1.useContext(ModalContext);
    if (!context) {
        throw new Error('Modal subcomponents (ModalHeader, ModalBody, ModalContainer, ModalFooter, ModalCloseButton) must be used inside <Modal>');
    }
    return context;
}
exports.useModalContext = useModalContext;
//# sourceMappingURL=useModalContext.js.map